/* eslint-disable array-callback-return */
import { useContext, useState, useEffect } from "react";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import CampaignContext from "../../../context/CampaignsContext/CampaignContext";
import { AdminContext } from "../../../context/AdminContext/AdminContext";
import { clearCampaignsModal } from "../../../context/CampaignsContext/Actions";
import {
  CREATE_CAMPAIGN,
  GET_ALL_CAMPAIGNS,
} from "../../../Querys/campaigns/querys";
import { GET_USERS_BY_CAMPUS_OR_PROJECT } from "../../../Querys/prestaciones/querys";
import { GET_ALL_PROJECT, GET_ALL_SEDE } from "../../../Querys/querys";
import AdminColaboradoresKpi from "./AdminColaboradoresKpi";
import { createUserKpiModal } from "../../../context/CampaignsContext/Actions";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
} from "@material-ui/core";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Form } from "semantic-ui-react";
import Add from "../../../assets/svg/addPrestacion.svg";
import { useFormik } from "formik";
import GreenSwitchPrestacion from "../../Prestaciones/modals/GreenSwitchPrestacion";
import * as Yup from "yup";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { ErrorAlert } from "../../../alerts/errorAlert";
import DateRangeField from "../../MyMood/Fields/DateRangeField";
import { addDays, subMonths, format, isEqual, parseISO } from "date-fns";
import { v4 as uuidv4 } from "uuid";
import { formatterMxn } from "../../../helpers/formatoMoneda";
import "../css/ModalCampaign.css";

const changeFormatBono = (typeBond: any, desBond: any) => {
  switch (typeBond) {
    case "Monto Fijo":
      let valueFormatted = parseFloat(desBond).toFixed(2);
      let valPesos = formatterMxn(valueFormatted);
      const valFin = valPesos === "nan" ? "" : valPesos;
      return valFin;
    case "Porcentaje de ingreso":
      const valueMetricObjetic = desBond;
      const value = parseFloat(valueMetricObjetic);
      const valPor = isNaN(value) ? "" : `${value} %`;
      return valPor;
    default:
      return typeBond;
  }
};

const handleCleanFormat = (value: any) => {
  const clean = String(value);
  if (clean.includes("$")) {
    return clean.replace("$", "").replaceAll(",", "");
  }
  if (clean.includes("%")) {
    return clean.replace("%", "").replaceAll(",", "");
  }
  return clean;
};

const CreateDuplicateCampaigns = () => {
  const { state, dispatch } = useContext(CampaignContext);
  const { adminState } = useContext(AdminContext);
  const [sedes, setSedes] = useState<any>([]);
  const [projects, setProjects] = useState<Array<any>>([]);
  const [selectedAllSedes, setSelectedAllSedes] = useState<String[]>([]);
  const [selectedAllProjects, setSelectedAllProjects] = useState<String[]>([]);
  const [campaignBond, setCampaignBond] = useState(false);
  const [campaignBondDisabledInput, setCampaignBondDisabledInput] =
    useState(true);
  const [usersByCampusProject, setUsersByCampusProject] = useState<Array<any>>(
    []
  );
  const [colaboradoresBD, setColaboradoresBD] = useState<Array<any>>([]);
  const [selectedUser, setSelectedUser] = useState<String[]>([]);
  const [tipodeBono] = useState([
    { id: uuidv4(), nameTipoBono: "Monto Fijo", value: "Monto Fijo" },
    {
      id: uuidv4(),
      nameTipoBono: "Porcentaje de ingreso",
      value: "Porcentaje de ingreso",
    },
  ]);
  const [selectedTipodeBono, setSelectedTipodeBono] = useState<String[]>([]);
  const [errorBono, SetErrorBono] = useState(false);
  const [errorTipoBono, SetErrorTipoBono] = useState(false);
  const [counterTxt, setCounterTxt] = useState(0);
  const [TypeBond, setTypeBond] = useState("");
  const [stateCalendario, setStateCalendario] = useState([
    {
      startDate: subMonths(new Date(), 0),
      endDate: addDays(new Date(), 0),
      key: "selection",
    },
  ]);
  const [initialValuesForm, setInitialValuesForm] = useState({
    nameCampaign: "",
    sedes: "",
    areas: "",
    minObjectives: "",
    maxObjectives: "",
    minQualification: "",
    descriptionBond: "",
    descriptionCampaign: "",
  });
  const [startDate, setStartDate] = useState(
    subMonths(new Date(), 0).toString()
  );
  const [endDate, setEndDate] = useState(subMonths(new Date(), 0).toString());
  const { data: resultSede } = useQuery(GET_ALL_SEDE);
  const allSede = resultSede?.GET_ALL_SEDE;
  const { data: resultProject } = useQuery(GET_ALL_PROJECT);
  const allProject = resultProject?.GET_ALL_PROJECT;
  const [getUserByCampusProject] = useLazyQuery(GET_USERS_BY_CAMPUS_OR_PROJECT);

  const validationSchema = () => {
    return {
      nameCampaign: Yup.string().required("Obligatorio"),
      sedes: Yup.array()
        .required("Obligatorio")
        .test(
          "sedes",
          "Es necesario seleccionar un proyecto",
          function (value) {
            if (value === undefined || value.length === 0) {
              return false;
            } else {
              return true;
            }
          }
        ),
      areas: Yup.array()
        .required("Obligatorio")
        .test("areas", "Es necesario seleccionar una sede", function (value) {
          if (value === undefined || value.length === 0) {
            return false;
          } else {
            return true;
          }
        }),
      minObjectives: Yup.number()
        .required("Obligatorio")
        .positive("Tiene que ser un número positivo")
        .min(0, "Debe ser un número positivo")
        .max(99, "No puede ser mayor a 99"),
      maxObjectives: Yup.number()
        .required("Obligatorio")
        .positive("Tiene que ser un número positivo")
        .max(99, "No puede ser mayor a 99"),
      minQualification: Yup.number()
        .required("Obligatorio")
        .positive("Tiene que ser un número positivo")
        .max(100, "No puede ser mayor a 100"),
    };
  };

  const [createCampaign] = useMutation(CREATE_CAMPAIGN, {
    refetchQueries: [{ query: GET_ALL_CAMPAIGNS }],
  });

  useEffect(() => {
    if (allSede) {
      setSedes(allSede);
    }
  }, [allSede]);

  useEffect(() => {
    if (allProject) {
      setProjects(allProject);
    }
  }, [allProject]);

  const onChangeLocation = (e: any) => {
    if (e.target.value.indexOf("Todas") > -1) {
      if (sedes.length === selectedAllSedes.length) {
        setSelectedAllSedes([]);
      } else {
        let filtered = sedes.map((item: any) => item.sedeName);
        setSelectedAllSedes(filtered);
      }
    } else {
      setSelectedAllSedes(e.target.value);
    }
  };

  const onChangeProject = (e: any) => {
    if (e.target.value.indexOf("Todas") > -1) {
      if (projects.length === selectedAllProjects.length) {
        setSelectedAllProjects([]);
      } else {
        let filtered = projects.map((item: any) => item.proyectName);
        setSelectedAllProjects(filtered);
      }
    } else {
      setSelectedAllProjects(e.target.value);
    }
  };

  const handleAdminColaborador = async () => {
    if (selectedAllSedes.length === 0 || selectedAllProjects.length === 0) {
      ErrorAlert({ text: "Seleccione el Area y Sede" });
      return;
    } else {
      setUsersByCampusProject([]);
      const proyectsName = selectedAllProjects.map((name: any) => {
        const nameSplit = name.split("/");
        return nameSplit[0];
      });
      let { data } = await getUserByCampusProject({
        variables: {
          input: {
            sede: selectedAllSedes,
            projects: proyectsName,
          },
        },
      });

      if (data.GET_USERS_BY_CAMPUS_OR_PROJECT.length > 0) {
        setUsersByCampusProject(data.GET_USERS_BY_CAMPUS_OR_PROJECT);
        createUserKpiModal(state._id, true, dispatch);
      } else {
        ErrorAlert({
          text: "No hay colaboradores con los valores seleccionados",
        });
      }
    }
  };

  const onchageTypebond = (e: any) => {
    if (selectedTipodeBono.length > 0) {
      setSelectedTipodeBono([]);
      setTypeBond("");
      SetErrorTipoBono(false);
    } else {
      setSelectedTipodeBono(e.target.value);
      setTypeBond(e.target.value[0]);
      SetErrorTipoBono(false);
    }
  };

  useEffect(() => {
    if (campaignBond === false) {
      setCampaignBondDisabledInput(true);
    } else {
      setCampaignBondDisabledInput(false);
    }
  }, [campaignBond]);

  useEffect(() => {
    const arraySedes: any = [];
    state.campaign?.sedes.map((sede: any) => {
      arraySedes.push(sede?.sede);
    });

    setSelectedAllSedes(arraySedes);
    const arrayProjects: any = [];
    state.campaign?.areas.map((area: any) => {
      arrayProjects.push(area.area);
    });

    setColaboradoresBD(state.campaign?.collaborators);
    setSelectedAllProjects(arrayProjects);
    setInitialValuesForm({
      nameCampaign: state.campaign?.nameCampaign,
      sedes: arraySedes,
      areas: arrayProjects,
      minObjectives: state.campaign?.minObjectives,
      maxObjectives: state.campaign?.maxObjectives,
      minQualification: state.campaign?.minQualification,
      descriptionBond: state.campaign?.descriptionBond,
      descriptionCampaign: state.campaign?.descriptionCampaign,
    });
    setCounterTxt(state.campaign?.descriptionCampaign.length);
    const bolCmapaignBond =
      state.campaign?.campaignBond === "true" ? true : false;
    setCampaignBond(bolCmapaignBond);
    setSelectedTipodeBono([state?.campaign?.typeBond]);
    setTypeBond(state?.campaign?.typeBond);
    setStartDate(
      addDays(new Date(state.campaign?.startCampaign), 1).toString()
    );
    setEndDate(addDays(new Date(state.campaign?.endCampaign), 1).toString());
  }, [state.createDuplicateCampaigns]);

  const resetStates = () => {
    setSelectedAllSedes([]);
    setSelectedAllProjects([]);
    setCampaignBond(false);
    setCampaignBondDisabledInput(true);
    SetErrorBono(false);
    SetErrorTipoBono(false);
    setCounterTxt(0);
  };

  const counterArea = (e: any) => {
    setCounterTxt(e.length);
  };
  const handleSetFormat = () => {
    const value = formik.values.descriptionBond;
    SetErrorBono(false);
    const format = changeFormatBono(TypeBond, value);
    formik.setFieldValue("descriptionBond", format);
  };

  const formik = useFormik({
    initialValues: initialValuesForm,
    enableReinitialize: true,
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (formData, { resetForm }) => {
      const initDate: any = format(stateCalendario[0].startDate, "yyyy-MM-dd");
      const endDate: any = format(stateCalendario[0].endDate, "yyyy-MM-dd");
      const dateEqual = isEqual(parseISO(initDate), parseISO(endDate));
      let descriptionBond = handleCleanFormat(formData.descriptionBond);

      if (campaignBond && TypeBond === "") {
        return SetErrorTipoBono(true);
      } else {
        SetErrorTipoBono(false);
      }

      if (campaignBond && formData?.descriptionBond === "") {
        return SetErrorBono(true);
      } else {
        SetErrorBono(false);
      }

      if (selectedUser.length === 0 && colaboradoresBD.length === 0) {
        ErrorAlert({ text: "Es necesario agregar usuarios a la campaña" });
        return;
      }

      let arrayUserSel: any = [];
      let objUserSel: {};

      if (colaboradoresBD.length > 0 && selectedUser.length === 0) {
        colaboradoresBD.map((selUser: any) => {
          objUserSel = { id: selUser.id };
          arrayUserSel.push(objUserSel);
        });
      } else {
        selectedUser.map((selUser: any) => {
          objUserSel = { id: selUser.id };
          arrayUserSel.push(objUserSel);
        });
      }
      if (campaignBond && formData?.descriptionBond === "") {
        SetErrorBono(true);
        return;
      } else {
        SetErrorBono(false);
      }
      const minObjectives = formData?.minObjectives;
      const maxObjectives = formData?.maxObjectives;
      if (minObjectives > maxObjectives) {
        ErrorAlert({
          text: "Los objetivos mínimos deben ser menores que los máximos",
        });
        return;
      }
      if (dateEqual) {
        ErrorAlert({ text: "Necesita seleccionar un rango" });
        return;
      }
      const variablesCampaign = {
        ...formData,
        campaignBond,
        sedes: selectedAllSedes,
        areas: selectedAllProjects,
        descriptionBond,
        collaborators: arrayUserSel,
        startCampaign: initDate,
        endCampaign: endDate,
        typeBond: TypeBond,
        idAdmin: adminState?.id,
      };
      try {
        let { data } = await createCampaign({
          variables: {
            input: variablesCampaign,
          },
        });
        setSelectedAllSedes([]);
        setSelectedAllProjects([]);
        setSelectedTipodeBono([]);
        setColaboradoresBD([]);
        setCampaignBond(false);
        setCampaignBondDisabledInput(true);
        setUsersByCampusProject([]);
        setSelectedUser([]);
        resetForm();
        clearCampaignsModal(false, dispatch);
        SetErrorBono(false);
        SetErrorTipoBono(false);
        setCounterTxt(0);
        SuccessfulAlert({ text: "Campaña creada correctamente." });
      } catch (e) {
        ErrorAlert({ text: "Ocurrió un error al crear la campaña" });
        console.log("error: ", e);
      }
    },
  });

  return (
    <>
      <Dialog
        open={state.createDuplicateCampaigns}
        aria-labelledby="form-dialog-title"
      >
        <IconButton
          aria-label="close"
          onClick={() => {
            formik.resetForm();
            resetStates();
            clearCampaignsModal(false, dispatch);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Form
            onSubmit={formik.handleSubmit}
            className="containerMdalPrestacion"
          >
            <DialogTitle>
              <span className="titlePrestacion">Duplicar campaña</span>
            </DialogTitle>
            <DialogContent className="oneComponentCampaign">
              <TextField
                type="text"
                name="nameCampaign"
                label="Nombre de la campaña*"
                variant="outlined"
                size="small"
                fullWidth={true}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.nameCampaign}
                inputProps={{ maxLength: 100 }}
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
                error={
                  formik.touched.nameCampaign &&
                  Boolean(formik.errors.nameCampaign)
                }
                helperText={
                  formik.touched.nameCampaign && formik.errors.nameCampaign
                }
              />
            </DialogContent>
            <DialogContent className="twoComponent">
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                className="question"
              >
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ backgroundColor: "#FFFFFF" }}
                >
                  Sede*
                </InputLabel>
                <Select
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "220px",
                    height: "40px",
                  }}
                  value={selectedAllSedes}
                  onChange={(e) => {
                    formik.handleChange(e);
                    onChangeLocation(e);
                  }}
                  labelId="demo-simple-select-label"
                  id="sedes"
                  name="sedes"
                  multiple
                  renderValue={(selected: any) => selected.join(", ")}
                  error={formik.touched.sedes && Boolean(formik.errors.sedes)}
                >
                  <MenuItem key={0} value={"Todas"}>
                    <Checkbox
                      checked={selectedAllSedes.length === sedes.length}
                      style={{
                        color: "#FABB00",
                      }}
                    />
                    <ListItemText primary={"Todas"} />
                  </MenuItem>
                  {sedes.map((item: any) => (
                    <MenuItem key={item.id} value={item.sedeName}>
                      <Checkbox
                        checked={selectedAllSedes.indexOf(item.sedeName) > -1}
                        style={{
                          color: "#FABB00",
                        }}
                      />
                      <ListItemText primary={item.sedeName} />
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: "red" }}>
                  {formik.touched.sedes && formik.errors.sedes}
                </FormHelperText>
              </FormControl>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                className="question"
                error={formik.touched.areas && Boolean(formik.errors.areas)}
              >
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ backgroundColor: "#FFFFFF" }}
                >
                  &Aacute;rea *
                </InputLabel>
                <Select
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "232px",
                    height: "40px",
                  }}
                  value={selectedAllProjects}
                  onChange={(e) => {
                    formik.handleChange(e);
                    onChangeProject(e);
                  }}
                  labelId="demo-simple-select-label"
                  id="areas"
                  name="areas"
                  multiple
                  renderValue={(selected: any) => selected.join(",")}
                  error={formik.touched.areas && Boolean(formik.errors.areas)}
                >
                  <MenuItem key={0} value={"Todas"}>
                    <Checkbox
                      checked={selectedAllProjects.length === projects.length}
                      style={{
                        color: "#FABB00",
                      }}
                    />
                    <ListItemText primary={"Todas"} />
                  </MenuItem>
                  {projects.map((project: any) => (
                    <MenuItem key={project.id} value={project.proyectName}>
                      <Checkbox
                        checked={
                          selectedAllProjects.indexOf(project.proyectName) > -1
                        }
                        style={{
                          color: "#FABB00",
                        }}
                      />
                      <ListItemText primary={project.proyectNameAndClient} />
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: "red" }}>
                  {formik.touched.areas && formik.errors.areas}
                </FormHelperText>
              </FormControl>
            </DialogContent>
            <DialogContent className="oneComponentCampaign">
              <button
                className="btnAdminColaboradorKpi"
                type="button"
                onClick={() => handleAdminColaborador()}
              >
                {`Administrar colaboradores (${
                  selectedUser?.length > 0
                    ? selectedUser?.length
                    : colaboradoresBD?.length
                })`}
              </button>
            </DialogContent>
            <DialogContent className="twoComponent">
              <TextField
                type="number"
                name="minObjectives"
                label="Mínimo de objetivos *"
                variant="outlined"
                size="small"
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value < 0 || value > 100) return; // Evita valores fuera del rango 0-100
                  formik.handleChange(e);
                }}
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
                value={formik.values.minObjectives}
                inputProps={{
                  maxLength: 100,
                  min: 0,
                  max: 99,
                  style: {
                    width: "120px",
                  },
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
                error={
                  formik.touched.minObjectives &&
                  Boolean(formik.errors.minObjectives)
                }
                helperText={
                  formik.touched.minObjectives && formik.errors.minObjectives
                    ? formik.errors.minObjectives
                    : " "
                }
                FormHelperTextProps={{
                  style: { fontSize: "11px", minHeight: "16px" },
                }}
              />

              <TextField
                type="number"
                name="maxObjectives"
                label="Máximo de objetivos *"
                variant="outlined"
                size="small"
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value < 0 || value > 100) return; // Evita valores fuera del rango 0-100
                  formik.handleChange(e);
                }}
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
                value={formik.values.maxObjectives}
                inputProps={{
                  maxLength: 100,
                  min: 0,
                  max: 99,
                  style: {
                    width: "120px",
                  },
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
                error={
                  formik.touched.maxObjectives &&
                  Boolean(formik.errors.maxObjectives)
                }
                helperText={
                  formik.touched.maxObjectives && formik.errors.maxObjectives
                    ? formik.errors.maxObjectives
                    : " "
                }
                FormHelperTextProps={{
                  style: { fontSize: "11px" },
                }}
              />
              <TextField
                type="number"
                name="minQualification"
                label="Calificación mínima *"
                variant="outlined"
                size="small"
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value < 0 || value > 100) return; // Evita valores fuera del rango 0-100
                  formik.handleChange(e);
                }}
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
                value={formik.values.minQualification}
                inputProps={{
                  maxLength: 100,
                  min: 0,
                  max: 100,
                  style: {
                    width: "105px",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
                error={
                  formik.touched.minQualification &&
                  Boolean(formik.errors.minQualification)
                }
                helperText={
                  formik.touched.minQualification &&
                  formik.errors.minQualification
                    ? formik.errors.minQualification
                    : " "
                }
                FormHelperTextProps={{
                  style: { fontSize: "11px" },
                }}
              />
            </DialogContent>
            <DialogContent className="twoComponent">
              <div className="twoComponentBono">
                <div className="bonoCampaign">
                  <span className="spanBonoCampaign">Bono de Campaña</span>
                </div>
                <GreenSwitchPrestacion
                  valor={campaignBond}
                  setValor={setCampaignBond}
                />
              </div>
              <div className="contTxtBono">
                <FormControl
                  fullWidth
                  size="small"
                  variant="outlined"
                  className="question"
                >
                  <InputLabel
                    id="demo-simple-select-label"
                    style={{ backgroundColor: "#FFFFFF" }}
                  >
                    Tipo de bono*
                  </InputLabel>
                  <Select
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      width: "220px",
                      height: "40px",
                    }}
                    value={selectedTipodeBono}
                    onChange={(e) => {
                      onchageTypebond(e);
                    }}
                    labelId="demo-simple-select-label"
                    id="tipoBono"
                    name="tipoBono"
                    disabled={campaignBondDisabledInput}
                    multiple
                    renderValue={(selected: any) => selected.join(",")}
                  >
                    {tipodeBono.map((tipoBono: any) => (
                      <MenuItem key={tipoBono.id} value={tipoBono.value}>
                        <Checkbox
                          checked={
                            selectedTipodeBono.indexOf(tipoBono.nameTipoBono) >
                            -1
                          }
                          style={{
                            color: "#FABB00",
                          }}
                        />
                        <ListItemText primary={tipoBono.nameTipoBono} />
                      </MenuItem>
                    ))}
                  </Select>
                  {errorTipoBono && (
                    <FormHelperText style={{ color: "red", marginLeft: "1px" }}>
                      Obligatorio
                    </FormHelperText>
                  )}
                </FormControl>
                <div className="textFieldBono">
                  <TextField
                    type="text"
                    name="descriptionBond"
                    label="Escribir bono*"
                    variant="outlined"
                    size="small"
                    fullWidth={true}
                    onBlur={() => handleSetFormat()}
                    onChange={(e) => {
                      if (Number(e.target.value) < 0) return;
                      formik.handleChange(e);
                    }}
                    onKeyPress={(event: any) => {
                      if (!/^[0-9.]+$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }
                    }}
                    value={formik.values.descriptionBond}
                    inputProps={{
                      maxLength: 120,
                      style: {
                        width: "120px",
                      },
                    }}
                  />
                </div>
                {errorBono && (
                  <FormHelperText style={{ color: "red" }}>
                    Obligatorio
                  </FormHelperText>
                )}
              </div>
            </DialogContent>
            <DialogContent className="oneComponentCampaign">
              <DateRangeField
                setDate={setStateCalendario}
                containerClass={"fieldsetInput"}
                daySelected1={startDate}
                daySelected2={endDate}
              ></DateRangeField>
            </DialogContent>
            <DialogContent className="oneComponentCampaign">
              <TextField
                id="outlined-multiline-static"
                label="Descripción de la campaña"
                multiline
                defaultValue={state.campaign?.descriptionCampaign}
                name="descriptionCampaign"
                onBlur={formik.handleBlur}
                onChange={(e: any) => {
                  formik.handleChange(e);
                  counterArea(e.target.value);
                }}
                fullWidth={true}
                rows={3}
                variant="outlined"
                inputProps={{ maxLength: 150 }}
              />
              <div className="divCounterArea">
                <label className="txtConterPres">{`${counterTxt}/150`}</label>
              </div>
            </DialogContent>
            <DialogContent className="twoComponentBtns">
              <div className="containerButtons">
                <div className="containerCancelPreestacion">
                  <button
                    className="btnCancelPrestacion"
                    type="button"
                    onClick={() => {
                      formik.resetForm();
                      resetStates();
                      clearCampaignsModal(false, dispatch);
                    }}
                  >
                    Cancelar
                  </button>
                </div>
                <div className="containerAddPrestacion">
                  <button className="btnAddPrestacion" type="submit">
                    <div className="infobtnAddRestriccion">
                      <div>
                        <img src={Add} alt="add" />
                      </div>
                      <div>
                        <span className="txtBtnAdd">Crear Campaña </span>{" "}
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </DialogContent>
          </Form>
        </DialogContent>
      </Dialog>
      {usersByCampusProject.length > 0 ? (
        <AdminColaboradoresKpi
          users={usersByCampusProject}
          userSelect={selectedUser}
          setSelectedUser={setSelectedUser}
          colaboradoresBD={colaboradoresBD}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default CreateDuplicateCampaigns;
